module.exports = __webpack_public_path__ + "img/image 6.a9796d64.png";